import { Box, styled } from '@mui/material';
import type { Column } from 'react-table';
import { BoxAction, Cell, DateTimeCell, Header } from 'shared/components/planner/common/utils';
import { LwButton } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { TFunctionNonStrict } from 'i18next';
import {
  PreferredWorkersCellProp,
  PreferredWorkersColumnDefinition,
} from '../preferred-workers-table.types';

export const getPreferredWorkersColumnDefinition: (
  t: TFunctionNonStrict<'partner-screen-specific', undefined>
) => Column<PreferredWorkersColumnDefinition>[] = (t) => {
  const workerFullName = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.worker', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'workerFullName',
    Cell: Cell,
    width: '200px',
  } as Column<PreferredWorkersColumnDefinition>;

  const workName = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.job_title', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'workName',
    Cell: Cell,
    width: '150px',
  } as Column<PreferredWorkersColumnDefinition>;

  const companyName = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.company', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'companyName',
    Cell: Cell,
    width: '180px',
  } as Column<PreferredWorkersColumnDefinition>;

  const departmentName = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.department', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'departmentName',
    Cell: Cell,
    width: '180px',
  } as Column<PreferredWorkersColumnDefinition>;

  const dateTime = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.date_time', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'dateTime',
    Cell: DateTimeCell,
    width: '170px',
  } as Column<PreferredWorkersColumnDefinition>;

  const actions = {
    Header: () => (
      <Header>
        {t('planning.preferred_flexible_workers.table_headers.action', {
          ns: 'partner-screen-specific',
        })}
      </Header>
    ),
    accessor: 'actions',
    Cell: ActionsCell,
    width: '180px',
  } as Column<PreferredWorkersColumnDefinition>;

  return [workerFullName, workName, companyName, departmentName, dateTime, actions];
};

const BoxActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
}));

const ActionsCell = (props: PreferredWorkersCellProp<'actions'>) => {
  const { onAccept, onReject } = props.value;

  return (
    <BoxAction>
      <BoxActions>
        {/* TODO: tertiary button https://levelworks.atlassian.net/browse/LW1-22847 */}
        <LwButton
          iconColorMode="stroke"
          startIcon={<IconApproved width={18} height={18} />}
          color="tertiary"
          sx={{
            '&.MuiButton-root': {
              border: 'none',
              padding: 0,
              '&:hover': {
                border: 'none',
                boxShadow: 'none',
                textDecoration: 'underline',
              },
            },
          }}
          onClick={() => onAccept()}
        >
          Accepteren
        </LwButton>
        {/* TODO: tertiary button https://levelworks.atlassian.net/browse/LW1-22847 */}
        <LwButton
          iconColorMode="fill"
          startIcon={<IconCancel width={18} height={18} />}
          color="tertiary"
          sx={{
            '&.MuiButton-root': {
              border: 'none',
              padding: 0,
              '&:hover': {
                border: 'none',
                boxShadow: 'none',
                textDecoration: 'underline',
              },
            },
          }}
          onClick={() => onReject()}
        >
          Afwijzen
        </LwButton>
      </BoxActions>
    </BoxAction>
  );
};
